import axios from '@/utils/axios'

export const getEntity = (payload) => {
    return axios.get('/entity', {
        params: payload
    })
}

export const createEntity = (data) => {
    return axios.post('/entity', data)
}

export const getEntityById = (id) => {
    return axios.get(`/entity/${id}`)
}

export const updateEntity = (id, data) => {
    return axios.put(`/entity/${id}`, data)
}

export const deleteEntity = (id) => {
    return axios.delete(`/entity/${id}`)
}